import axios from 'axios';
import { clearAuth } from '../utils/auth';

const api = axios.create({
  baseURL: process.env.REACT_APP_BORDERGARITA_API_URL
});

api.interceptors.request.use(config => {
  const isLoginRoute = config.url?.includes('/auth/login');

  if (!isLoginRoute) {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  return config;
}, error => {
  return Promise.reject(error);
});

api.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;
    if (status === 401) {
      clearAuth();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
